/**
 * Fan chrome. The divider line + SURFACE / SUBSURFACE headings rendered
 * over an open cell fan when the cell holds cards in both regions. Pure
 * DOM overlay: elements register refs and updateCellFanChrome projects
 * them into place each frame (same pattern as the expand buttons); they
 * start hidden and the projector shows them only while a two-region fan
 * is open. Pointer-transparent. Clicks fall through to the fan.
 */
import { t } from '../../localization/t';

export default function CellFanChrome({ open, registerRef }) {
  if (!open) return null;
  return (
    <div aria-hidden="true">
      <div ref={(el) => registerRef('divider', el)} className="cell-fan-divider" />
      <div ref={(el) => registerRef('surfaceLabel', el)} className="cell-fan-heading">{t('Surface')}</div>
      <div ref={(el) => registerRef('subsurfaceLabel', el)} className="cell-fan-heading">{t('Subsurface')}</div>
    </div>
  );
}
